import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Typography,
} from "@mui/material";
import { useSnackBar } from "src/context/SnackBarContext";
import { deleteData, postData } from "../utilities/api";
import Loader from "src/components/Loader";
import { useQueryClient } from "react-query";

const initialState = {
  id: null,
  name: "",
  phone: "",
  gender: "",
  address1: "",
  address2: "",
  email: "",
  appId: "",
};
function AddUser({ onCancel, selectedUser }) {
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  const { showSnackbar } = useSnackBar();
  const [data, setData] = useState(initialState);

  useEffect(() => {
    if (selectedUser) {
      console.log("sdf");
      setData({
        ...selectedUser,
        name: selectedUser.staffName,
        phone: selectedUser.Phone,
      });
    } else {
      setData(initialState);
    }
  }, [selectedUser]);

  const handleChange = (e) => {
    const { value, name } = e.target;

    // const values = { [name]: value };
    // console.log(values);
    setData({ ...data, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let endPoint;
    if (!selectedUser) {
      endPoint = "addUsersForAdmin";
    } else {
      endPoint = "editUsersForAdmin";
    }
    if (data) {
      setLoading(true);
      try {
        const submitData = await postData(`/api/${endPoint}`, data);
        if (submitData.success) {
          showSnackbar("success", submitData.message);
          onCancel();
          queryClient.invalidateQueries("staffData");
          setData(initialState);
        } else {
          showSnackbar("error", submitData.message);
        }
      } catch (err) {
        showSnackbar("error", err.message);
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
  };

  // delete user

  const handleDelete = async () => {
    if (data.id) {
      setLoading(true);
      try {
        const deleteUser = await deleteData(
          `/api/deleteUsersForAdmin?id=${data.uid}`
        );
        if (deleteUser.success) {
          showSnackbar("error", deleteUser.message);
          onCancel();
          queryClient.invalidateQueries("staffData");
        }
      } catch (err) {
        console.log(err);
        showSnackbar("error", err);
      } finally {
        setLoading(false);
      }
    } else {
      alert("User ID not available");
      setLoading(false);
    }
  };

  return (
    <>
      <Loader start={loading} />
      <Grid container spacing={2} component="form" onSubmit={handleSubmit}>
        <Grid item xs={12}>
          <Typography gutterBottom variant="h4">
            {" "}
            {selectedUser ? "Update" : "Create"}User
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            required
            label="Name"
            type="text"
            variant="outlined"
            onChange={handleChange}
            name="name"
            value={data.name}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            label="Phone"
            type="number"
            variant="outlined"
            name="phone"
            onChange={handleChange}
            value={data.phone}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Gender</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              name="gender"
              value={data.gender}
              label="Gender"
              onChange={handleChange}
            >
              <MenuItem value={"MALE"}>Male</MenuItem>
              <MenuItem value={"FEMALE"}>Female</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Address"
            type="text"
            variant="outlined"
            name="address1"
            onChange={handleChange}
            value={data.address1}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Address (Optional)"
            type="text"
            variant="outlined"
            name="address2"
            onChange={handleChange}
            value={data.address2}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Email"
            type="email"
            variant="outlined"
            name="email"
            onChange={handleChange}
            value={data.email}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            label="App Id"
            type="number"
            variant="outlined"
            name="appId"
            onChange={handleChange}
            value={data.appId || 0}
          />
        </Grid>
        <Grid item xs={12} textAlign="right">
          <Button variant="outlined" onClick={onCancel} sx={{ mr: 2 }}>
            Cancel
          </Button>
          {selectedUser && (
            <Button
              variant="contained"
              color="error"
              onClick={handleDelete}
              sx={{ mr: 2 }}
            >
              Delete
            </Button>
          )}
          <Button variant="contained" type="submit">
            {selectedUser ? "Update" : "Create"}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}

export default AddUser;

AddUser.propTypes = {
  onCancel: PropTypes.func,
  selectedUser: PropTypes.object,
};
